namespace GeniuzPOS.Member {
    export interface MbAmphurLookupRow {
        MbProvince?: string;
        MbAmphur?: string;
        MbTumbol?: string;
    }

    export namespace MbAmphurLookupRow {
        export const idProperty = 'MbAmphur';
        export const nameProperty = 'MbAmphur';
        export const localTextPrefix = 'Member.MbAmphurLookup';
        export const lookupKey = 'Member.MbAmphurLookup';

        export function getLookup(): Q.Lookup<MbAmphurLookupRow> {
            return Q.getLookup<MbAmphurLookupRow>('Member.MbAmphurLookup');
        }
        export const deletePermission = null;
        export const insertPermission = null;
        export const readPermission = '';
        export const updatePermission = null;

        export declare const enum Fields {
            MbProvince = "MbProvince",
            MbAmphur = "MbAmphur",
            MbTumbol = "MbTumbol"
        }
    }
}
